module.exports = __webpack_public_path__ + "static/img/BSMI_02.84c889be.jpg";